import accessors from '../accessors';
import isReloadSupposed from '../verifiers/is-reload-supposed';

const logBeforeReloadAction = () => (next) => (action) => {
  if (isReloadSupposed(action)) {
    accessors.getLogger().log(`${action.type} action is dispatched`, { action });
  }

  next(action);
};

export default logBeforeReloadAction;
